<template>
  <div class="w-full flex flex-row ml-4" :class="{ 'gs-context-header': studioReturn }">
    <funnel-studio-breadcrumb v-if="studioReturn" />
    <portal-target v-else name="headerBreadCrumb" class="flex"> </portal-target>
    <div class="flex flex-grow justify-between gs-header-title">
      <div class="flex text-sm font-semibold">
        <span class="pr-4 flex items-center">{{ routeTitle }}</span>
      </div>
    </div>
    <div class="flex items-center text-sm px-4 font-semibold gs-header-demo">
      <label class="mr-1">{{ $t('frontend_groovesell_headerbar_demo_mode') }}</label>
      <info-icon class="mr-4 cursor-pointer w-4 h-4 text-grey-500 fill-current" 
        v-tooltip="{
          classes: 'w-96',
          content: this.$t('frontend_groovesell_headerbar_demo_mode_tooltip'),
        }" />
      <gd-toggle v-model="toggle" :value="toggle" @change="changeDemoMode" />
    </div>
    <portal-target name="headerContent"> </portal-target>
  </div>
</template>
<script>
import FunnelStudioBreadcrumb from './FunnelStudioBreadcrumb.vue';
import { funnelStudioReturn } from '@/router/utils/funnel-studio-context';
import InfoIcon from '@/assets/images/icons/InfoIcon.svg';

export default {
  data() {
    return {
      toggle: this.$store.getters['internal/isDemoMode'],
    };
  },
  computed: { studioReturn() { return funnelStudioReturn(this.$route); } },
  components: {
    FunnelStudioBreadcrumb,
    InfoIcon,
  },
  methods: {
    async changeDemoMode() {
      await this.$store.dispatch('internal/changeDemoMode', this.toggle);
      window.location.reload();
    },
  },
  name: 'HeaderBar',
  props: ['routeTitle'],
};
</script>

<style scoped>
.gs-context-header { align-items:center; min-width:0; }
.gs-context-header .gs-header-title { min-width:0; }
.gs-context-header .gs-header-title>div { min-width:0; }
.gs-context-header .gs-header-title span { overflow:hidden; text-overflow:ellipsis; white-space:nowrap; display:block; }
.gs-context-header .gs-header-demo { flex-shrink:0; }
@media(max-width:700px) { .gs-context-header .gs-header-title { display:none; } .gs-context-header .gs-header-demo { margin-left:auto; padding-left:4px; padding-right:8px; } }
@media(max-width:430px) { .gs-context-header .gs-header-demo label { display:none; } }
</style>
